import { queryClient } from '@/lib/react-query';
import {
  UpdateDTO,
  useUpdateMutationFactory,
  UseUpdateMutationProps,
} from '@/lib/react-query/update';
import { Task } from '@/types';
import { update } from '@/utils/api';
import { featureKeys, featurePath, TaskSearchParams } from '.';

export type UpdateTaskDTO = UpdateDTO<Task, TaskSearchParams>;

const updateTask = ({ data, id, params = {} }: UpdateTaskDTO) =>
  update<Task>(`${featurePath}/${id}`, data, params);

export const useUpdateTask = (options?: UseUpdateMutationProps<Task>) => {
  return useUpdateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: updateTask,
    onSuccess: (data) => {
      if (data.parent_task_id !== null) {
        queryClient.invalidateQueries({
          queryKey: [{ scope: 'task', entity: 'detail', id: data.parent_task_id }],
        });
        if (data.parent_task?.taskable_type && data.parent_task?.taskable_id) {
          queryClient.invalidateQueries({
            queryKey: [
              {
                scope: data.parent_task.taskable_type,
                entity: 'detail',
                id: data.parent_task.taskable_id,
              },
            ],
          });
        }
      }
    },
    ...options,
  });
};
